import { render } from "./DailySummary.vue?vue&type=template&id=38d865ca"
import script from "./DailySummary.vue?vue&type=script&lang=ts"
export * from "./DailySummary.vue?vue&type=script&lang=ts"
script.render = render

export default script